import { render, staticRenderFns } from "./ReporteVentasDevoluciones.vue?vue&type=template&id=1aaf442d"
import script from "./ReporteVentasDevoluciones.vue?vue&type=script&lang=js"
export * from "./ReporteVentasDevoluciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports